import {ROLES, PERMS} from "modules/permissions/constants"

let getRoles = () => []

export const setRolesGetter = getter => {
  getRoles = getter
}

let getItemEntryAddToPosByDefault = () => null

export const setItemEntryAddToPosByDefaultGetter = getter => {
  getItemEntryAddToPosByDefault = getter
}

export const hasPerm = action => {
  const itemEntryAddToPosByDefault = getItemEntryAddToPosByDefault()
  const roles = getRoles()

  // this is sort of ad hoc, but allows clerks to charge arbitrary amounts at
  // POS by making a new item if the add to POS by default setting is enabled
  const baseClerkRoles = [PERMS.ADD_TRANSACTION, PERMS.TILL_DETAIL]
  const clerkRoles = itemEntryAddToPosByDefault
    ? [...baseClerkRoles, PERMS.ADD_ITEM]
    : baseClerkRoles

  let permitted = roles.includes(ROLES.ADMIN)

  permitted = permitted || (roles.includes(ROLES.CLERK) && clerkRoles.includes(action))

  permitted =
    permitted ||
    (roles.includes(ROLES.EMPLOYEE) &&
      [
        PERMS.ADD_TRANSACTION,
        PERMS.ADD_ITEM,
        PERMS.ADD_CONTACT,
        PERMS.ITEM_LIST,
        PERMS.ACCOUNT_LIST,
        PERMS.TRANSACTION_LIST,
        PERMS.ITEM_DETAIL,
        PERMS.ACCOUNT_DETAIL,
        PERMS.TRANSACTION_DETAIL,
        PERMS.TILL_DETAIL,
        PERMS.TABLE_ACTIONS,
        // Hack for Ruth Meteer
        PERMS.REPORTS_SALES,
      ].includes(action))

  permitted =
    permitted ||
    (roles.includes(ROLES.ANALYST) &&
      [
        PERMS.DASHBOARD,
        PERMS.REPORTS_NAVIGATION,
        PERMS.REPORTS_SALES,
        PERMS.ITEM_LIST,
        PERMS.ACCOUNT_LIST,
        PERMS.TRANSACTION_LIST,
        PERMS.GIFT_CARD_LIST,
      ].includes(action))

  return permitted
}
